import React, {Component} from 'react';
import classnames from 'classnames';
import Dropzone from 'react-dropzone';
import fetch from 'isomorphic-fetch';
import LocalizedStrings from '../../localization/strings';

import ButtonRound from '../button-round';
import Icon from '../icon';

export default class ImageInput extends Component {

    constructor(props) {
        super(props);
        this.state = {
            saving: false
        };
    }

    removeImage() {
        const {value} = this.props;
        this.setState({saving: true});
        fetch(`/api/images/${value}`, {method: 'DELETE'}).then(response => {
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            } else {
                throw new Error('failed to upload, resp', response.status);
            }
        }).then(() => {
            if (this.props.onChange) {
                this.props.onChange('');
            }
        }).catch(e => {
            console.error('failed to remove image', e);
        }).then(() => {
            this.setState({saving: false});
        });
    }

    onDrop(files) {
        const data = new FormData();
        data.append('image', files[0]);

        this.setState({saving: true});

        fetch('/api/images/', {
            method: 'POST',
            body: data
        }).then(response => {
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            } else {
                throw new Error('failed to upload, resp', response.status);
            }
        }).then(result => {
            if (this.props.onChange) {
                this.props.onChange(result.id);
                if (this.props.onImageUploaded){
                    this.props.onImageUploaded(result)
                }
            }
        }).catch(e => {
            console.error('failed to upload image', e);
        }).then(() => {
            this.setState({saving: false});
        });
    }

    render() {

        const {
            value,
            uploadLabel = LocalizedStrings.upload,
            className = null,
            iconSize = 'sm',
            inlineImg = true
        } = this.props;
        return (
            <div className={classnames('image-input', className, {
                'empty': !value
            }, {
                'not-empty': !!value
            })}>
                <Dropzone className="dropzone" onDrop={this.onDrop.bind(this)} accept="image/*" multiple={false}>
                    {(() => {
                        if (this.state.saving) {
                            return <Icon icon="spinner" spin={true}/>
                        } else if (value) {
                            if (inlineImg) {
                                return (
                                    <div className="image-display">
                                        <img key="img" src={window.CARE_CONFIG.image_storage_base_url + value}/>
                                        <ButtonRound title="remove image" className="remove" key="btn" icon="trash" type="empty" size="s" onClick={this.removeImage.bind(this)}/>
                                    </div>
                                );
                            } else {
                                return (
                                    <div className="delete-msg" onClick={this.removeImage.bind(this)}>
                                        <ButtonRound icon="trash" size={iconSize} type="empty"/>
                                        <span>{LocalizedStrings.remove}</span>
                                    </div>
                                );
                            }
                        } else {
                            return (
                                <div className="empty-msg">
                                    <ButtonRound icon="upload" size={iconSize} type="empty"/>
                                    <span>{uploadLabel}</span>
                                </div>
                            );
                        }

                    })()
}
                </Dropzone>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/components/form/image-field.js